// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lYGI","col":"styles_col__5EU9R"};